// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__sdA8l","row":"ProcedureTreatmentSummary_row__1mp2Y"};